import { h } from 'preact'
import { Link } from '../../../shared/Link'
import styles from './PageNotFound.css'
import { Message } from '../../../../../lib/intl/Message'
import { Profil } from '../../../shared/Decoration'
import { landsoversiktUrl } from '../../../../routes'
import { Icon } from '../../../shared/Icons/Icons'

export function PageNotFound() {
  return (
    <section class={styles.pageNotFound}>
      <h2>
        <Message id="fant-ikke-siden-tittel" />
      </h2>
      <p>
        <Message id="fant-ikke-siden-beskrivelse" />
      </p>
      <Link linkClickType="NOT-FOUND-BACK" href={landsoversiktUrl()} class="nrk-button">
        <Message id="fant-ikke-siden-lenketekst" />
        <Icon type="nrk-arrow-right" />
      </Link>
      <Profil inElement={true} id="ikke-funnet-banner" class={styles.bunnDekor} />
    </section>
  )
}
